export default __webpack_public_path__ + "static/media/social_share-purple.91e9b19f.png";